import { ProForm as OriginalProForm, ProFormGroup } from '@ant-design/pro-components';
import { withWrap } from '../../utils/hoc';
const ProForm = withWrap(OriginalProForm);
ProForm.Group = withWrap(ProFormGroup);
export default ProForm;
